import * as React from 'react';

const SvgIndustries = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M6.72 6.05l-3-1.5a.49.49 0 00-.44 0l-3 1.5A.51.51 0 000 6.5V14a.5.5 0 00.5.5H2a.5.5 0 00.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 00.5.5h1.5A.5.5 0 007 14V6.5a.51.51 0 00-.28-.45zM5 10.5H2a.5.5 0 010-1h3a.5.5 0 010 1zM5 8H2a.5.5 0 010-1h3a.5.5 0 010 1zM14 11.24a.49.49 0 00.59-.34 2.76 2.76 0 01.31-.7.48.48 0 00.1-.27V3a.5.5 0 00-.31-.46L8.69 0a.49.49 0 00-.47 0A.51.51 0 008 .5V14a.5.5 0 00.5.5h1a.5.5 0 00.49-.44 3.28 3.28 0 014-2.82zM10 4.5h3a.5.5 0 010 1h-3a.5.5 0 010-1zM10 7h3a.5.5 0 010 1h-3a.5.5 0 010-1zm3 3.5h-3a.5.5 0 010-1h3a.5.5 0 010 1z" />
      <circle cx={17.75} cy={17.03} r={1.5} />
      <path d="M23.52 18.41l-1-1.07a.46.46 0 010-.62l1-1.07a1.76 1.76 0 00.23-2.11 1.74 1.74 0 00-1.93-.84l-1.41.3a.46.46 0 01-.54-.31l-.42-1.39a1.77 1.77 0 00-3.4 0l-.43 1.39a.45.45 0 01-.53.31l-1.41-.33a1.78 1.78 0 00-1.7 3l1 1.07a.46.46 0 010 .62l-1 1.07a1.78 1.78 0 001.7 2.95l1.41-.38a.46.46 0 01.53.32l.43 1.39a1.78 1.78 0 003.4 0l.42-1.39a.44.44 0 01.53-.32l1.42.32a1.75 1.75 0 001.93-.84 1.77 1.77 0 00-.23-2.07zM17.75 20a3 3 0 113-3 3 3 0 01-3 3z" />
    </svg>
  );
};

export default SvgIndustries;
